import {Button} from '@wandb/components';
import React, {useCallback} from 'react';

import {trackMarimoClickViewNotebook} from '../../../../services/analytics/productEvents';
import {useRampFlagMarimoNotebooks} from '../../../../util/rampFeatureFlags/rampFeatureFlags';
import {useOnClickViewNotebookButtonInSettings} from './useOnCreateNotebookClick';

export const ViewNotebookButton = ({
  notebookId,
  canEdit,
}: {
  notebookId: string;
  canEdit: boolean;
}) => {
  const isRuntimeEnabled = useRampFlagMarimoNotebooks();
  const onClick = useOnClickViewNotebookButtonInSettings(notebookId, canEdit);
  const onClickWithTracking = useCallback(() => {
    trackMarimoClickViewNotebook({notebookId, source: 'panel-settings'});
    onClick();
  }, [onClick, notebookId]);
  if (!isRuntimeEnabled) {
    return null;
  }
  return (
    <Button
      variant="secondary"
      endIcon="open-new-tab"
      onClick={onClickWithTracking}>
      View notebook
    </Button>
  );
};
